export const Functions = {
  create: false,
  delete: false,
  detail: true,
  search: true,
};
